<!-- white-block template -->
<template>
  <div>
    <!-- ヘッダーバー -->
    <div class="headerBar">
      <span class="headerBarTitle">まぐまぐ新聞</span>
      <span class="headerBarIssueDay"
        >２０２０年（令和２年）１２月１４日（月）</span
      >
      <span class="headerBarIssueYear">（年刊）</span>
    </div>
    <nav class="hamburgerMenu">
      <!--ハンバーガーメニューのボタン-->
      <div class="hamburger_btn" v-on:click="ActiveBtn = !ActiveBtn">
        <span
          class="line line_01"
          v-bind:class="{ btn_line01: ActiveBtn }"
        ></span>
        <span
          class="line line_02"
          v-bind:class="{ btn_line02: ActiveBtn }"
        ></span>
        <span
          class="line line_03"
          v-bind:class="{ btn_line03: ActiveBtn }"
        ></span>
      </div>
      <!--サイドバー-->
      <transition name="menu">
        <div class="menu" v-show="ActiveBtn">
          <ul>
            <li class="toTop">
              <a :href="item.homeUrl"><span>TOP</span></a>
            </li>
            <li>
              <a :href="item.cateUrl + 'top5.html'" id="top5-link"
                ><span>総合大賞</span></a
              >
            </li>
            <li>
              <a :href="item.cateUrl + 'new-face.html'" id="new-face-link"
                ><span>新人賞</span></a
              >
            </li>
            <li class="nav_ul_subtitle"><span>メディア賞</span></li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'news.html'" id="news-link"
                ><span class="font_w_slim">MAG2 NEWS賞</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'money.html'" id="money-link"
                ><span class="font_w_slim">MONEY VOICE賞</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'tripeditor.html'" id="tripeditor-link"
                ><span class="font_w_slim">TRiP EDiTOR賞</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'bythem.html'" id="tripeditor-link"
                ><span class="font_w_slim">by them賞</span></a
              >
            </li>
            <li class="nav_ul_subtitle"><span>ジャンル別賞</span></li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'business.html'" id="business-link"
                ><span class="font_w_slim">ビジネス</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a
                :href="item.cateUrl + 'news-commentary.html'"
                id="news-commentary-link"
                ><span class="font_w_slim">時事解説</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'journalism.html'" id="journalism-link"
                ><span class="font_w_slim">ジャーナリズム</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'specialty.html'" id="specialty-link"
                ><span class="font_w_slim">専門情報</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'political.html'" id="political-link"
                ><span class="font_w_slim">政治経済</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'management.html'" id="management-link"
                ><span class="font_w_slim">起業・経営</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'career.html'" id="career-link"
                ><span class="font_w_slim">キャリアアップ</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'asset-stock.html'" id="asset-stock-link"
                ><span class="font_w_slim">資産運用&nbsp;(株式)</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'asset-fx.html'" id="asset-fx-link"
                ><span class="font_w_slim"
                  >資産運用&nbsp;(FX･先物･債券)</span
                ></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'asset-es.html'" id="asset-es-link"
                ><span class="font_w_slim">資産運用&nbsp;(不動産)</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'knowledge.html'" id="knowledge-link"
                ><span class="font_w_slim">知識・ノウハウ</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'psychology.html'" id="psychology-link"
                ><span class="font_w_slim">こころ</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a
                :href="item.cateUrl + 'self-developement.html'"
                id="psychology-link"
                ><span class="font_w_slim">自分磨き</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a
                :href="item.cateUrl + 'mental-training.html'"
                id="mental-training-link"
                ><span class="font_w_slim">メンタルトレーニング</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'safety.html'" id="safety-link"
                ><span class="font_w_slim">安全・防災</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'language.html'" id="language-link"
                ><span class="font_w_slim">語学</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'education.html'" id="education-link"
                ><span class="font_w_slim">教育</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'hobby.html'" id="hobby-link"
                ><span class="font_w_slim">趣味・娯楽</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'column.html'" id="column-link"
                ><span class="font_w_slim">コラム</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'life.html'" id="life-link"
                ><span class="font_w_slim">生活</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'love.html'" id="love-link"
                ><span class="font_w_slim">恋愛</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a :href="item.cateUrl + 'health.html'" id="health-link"
                ><span class="font_w_slim">健康</span></a
              >
            </li>
            <li class="nav_ul_item">
              <a
                :href="item.cateUrl + 'entertainment.html'"
                id="entertainment-link"
                ><span class="font_w_slim">エンタメ</span></a
              >
            </li>
          </ul>
        </div>
      </transition>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      ActiveBtn: false
    }
  }
}
</script>

<style scoped>
.headerBar {
  border-bottom: 1px solid #707070;
  padding: 12px 0;
  font-family: toppan-bunkyu-midashi-min-st, serif;
  font-weight: 900;
  font-style: normal;
  font-size: 12px;
  display: flex;
  justify-content: space-around;
}
.headerBar .headerBarTitle {
  width: 40%;
  text-align: center;
  letter-spacing: 14px;
}
.headerBarTitle a {
  color: #222;
  text-decoration: none;
}
.headerBar .headerBarIssueDay {
  width: 40%;
  text-align: center;
}
.headerBar .headerBarIssueYear {
  width: 20%;
  text-align: left;
}

@media screen and (max-width: 1024px) {
  .headerBar .headerBarTitle {
    width: 21%;
  }
  .headerBar .headerBarIssueDay {
    width: 41%;
  }
  .headerBar .headerBarIssueYear {
    width: 20%;
  }
}

/*ボタン*/
.hamburger_btn {
  position: absolute; /*常に最上部に表示したいので固定*/
  top: 0;
  right: 0;
  width: 56px;
  height: 50px;
  cursor: pointer;
  z-index: 50;
}

.hamburger_btn .line {
  position: absolute;
  top: 0;
  left: 26px;
  width: 22px;
  height: 4px;
  background: #777777;
  text-align: center;
}

.hamburger_btn .line_01 {
  top: 13px;
  transition: 0.4s ease;
}
.hamburger_btn .line_02 {
  top: 20px;
  transition: 0.4s ease;
}
.hamburger_btn .line_03 {
  top: 27px;
  transition: 0.4s ease;
}

.btn_line01 {
  transform: translateY(9px) rotate(-45deg);
  transition: 0.4s ease;
}
.btn_line02 {
  transition: 0.4s ease;
  opacity: 0;
}
.btn_line03 {
  transform: translateY(-5px) rotate(45deg);
  transition: 0.4s ease;
}

/*サイドバー*/
.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.4s;
}
.menu-enter,
.menu-leave-to {
  opacity: 0;
}
.menu-leave,
.menu-enter-to {
  opacity: 1;
}

.menu li {
  list-style: none;
  line-height: 1;
  padding: 0.3rem;
  width: calc((100% / 2) - 0px);
  display: flex;
  margin: 1px 0 0;
}
.menu li.nav_ul_subtitle {
  width: 100%;
}
.menu li.nav_ul_subtitle span {
  color: #d2ac31;
  margin: 10px auto 4px;
  display: block;
}

.menu li.toTop {
  width: 100%;
  margin: 0 0 15px;
  text-align: center;
}

.menu li.toTop a {
  width: 50% !important;
  display: block;
  margin: 0 auto;
}

.menu {
  background-color: rgba(255, 255, 255, 0.971);
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  z-index: 30;
  padding: 0.3rem;
  position: absolute;
  width: 20rem;
  top: 0;
  right: 0;
  overflow: auto;
  height: 100vh;
}
.menu a {
  color: #222;
  text-decoration: none;
  font-size: 14px;
  padding: 5px;
  background: #e0e0e0;
  border-radius: 8px;
  width: 100%;
  text-align: center;
  line-height: 1.3;
  align-self: center;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  height: 100%;
  align-self: center;
  display: flex;
  justify-content: center;
}
.menu a:hover {
  position: relative;
  content: '';
  background: #d4af37;
  color: #fff;
}
.menu a span {
  align-self: center;
}

.menu ul {
  margin: 0 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-self: flex-start;
}
@media screen and (max-width: 400px) {
  .menu {
    height: 94vh;
  }
}
</style>
